<style lang="scss">
  @import "../styles/stripe-element/onboarding-payment-form.scss";
</style>

<template>
  <div id="onboarding-payment-form-container">
    <div class="spinner" v-if="isLoading">
      <v-progress-circular :width="3" color="primary" indeterminate></v-progress-circular>
      <span>Loading</span>
    </div>
    <v-radio-group v-model="defaultSelected" @change="onClickPaymentMethod" hide-details class="radio-group">
      <StripePaymentForm ref="payment-form" class="payment-form"
        @onPaymentMethodChange="onPaymentMethodChange"
        @onFullFillPayment="onFullFillPayment"
        @onLoadPaymentIntentDone="onLoadPaymentIntentDone"
        @onStripePaymentError="onStripePaymentError"
        :services="services"
        :companyId="companyId"
        :companyName="companyName"
        :maxRetry="maxRetry"
        :paymentMethodTypes="paymentMethodTypes"
        :couponCode="couponCode" />

      <v-radio color="primary" value="bank_transfer" class="payment-radio" v-if="isShowBankTransfer && !isLoading">
        <template slot="label">
          <v-icon color="grey darken-1">account_balance</v-icon><span class="payment-radio-label">
            {{ this.$t("$onboarding.content_paragraph.payment.summary.mode_of_payment.selection.bank") }}</span>
        </template>
      </v-radio>
    </v-radio-group>
  </div>
</template>

<script>

import PaymentServiceProxy from "@/proxies/back-end/subscriptions/payment.microservice";
import LocalStoreManager from "@/utilities/local-store-manager";
import StripePaymentForm from "./StripePaymentForm.vue";
import { ConfigMixin } from "@/mixins/config-mixin";
import { getAppFeatureProp } from "@/utilities/app-feature-util";

const handlePayWithPaymentMethod = async (component) => {
  const paymentForm = component.$refs["payment-form"];
  try {
    const confirmResult = await paymentForm.confirmPayment();
    component.$emit("onPaymentCreated", { ...paymentForm.payment, paymentIntentStatus: confirmResult.paymentIntent.status });
  } catch (error) {
    component.onStripePaymentError(error);
  }
}

const handlePayWithBank = async (component) => {
  try {
    const paymentProxy = new PaymentServiceProxy();

    const localStorage = new LocalStoreManager();
    const authToken = await localStorage.getItem("authToken");

    const payWithBankPayload = {
      companyId: component.companyId,
      companyName: component.companyName,
      paymentType: "onboarding",
      items: component.services,
      couponCode: component.couponCode,
    };

    const paymentBankTransfer = await paymentProxy.payWithBank({ authToken }, payWithBankPayload);

    component.$emit("onPaymentCreated", paymentBankTransfer);
  } catch (error) {
    component.onStripePaymentError(error);
  }
}

const handleSubmitPayment = async (component) => {
  // Handle stripe payment
  if (component.defaultSelected != "bank_transfer") {
    await handlePayWithPaymentMethod(component);
  }
}

export default {
  components: {
    StripePaymentForm
  },
  async created() {
    const appFeatureList = this.platformConfig.cmsGeneralFeatureList;
    const billingServiceCMS = getAppFeatureProp(appFeatureList, "billing_service");
    const paymentMethods = getAppFeatureProp(billingServiceCMS.props, "payment_methods");
    const bankTransfer = getAppFeatureProp(paymentMethods.props, "bank_transfer");
    const stripeElementProps = getAppFeatureProp(billingServiceCMS.props, "stripe_element");

    this.isShowBankTransfer = bankTransfer.enabled ?? true;
    this.excludeErrors = stripeElementProps.value.exclude_errors ?? [];
  },
  methods: {
    onStripePaymentError: function (error) {
      if (error.message && this.excludeErrors.includes(error.message)) {
        console.log("Excluded error: ", error.message);
        return;
      }

      this.$emit("onStripePaymentError", error);
    },
    onClickPaymentMethod: function () {
      console.log('Selected payment method: ', this.defaultSelected);
      this.$emit("paymentMethodChange", this.defaultSelected);
      this.$refs["payment-form"].onCloseAllPaymentMethods();
    },
    onPaymentMethodChange: function (paymentMethod) {
      console.log('Selected payment method: ', paymentMethod);
      this.$emit("paymentMethodChange", paymentMethod);

      // Refresh payment intent
      this.$refs["payment-form"].refresh();

      // Reset internal method
      if (['google_pay', 'apple_pay'].includes(paymentMethod)) {
        this.onFullFillPayment(true);
      }
      this.defaultSelected = paymentMethod;
    },
    submitPayment: function () {
      handleSubmitPayment(this);
    },
    submitPaymentWithUser: function () {
      handlePayWithBank(this);
    },
    onFullFillPayment: function (val) {
      this.$emit("onFullFillPayment", val);
    },
    onLoadPaymentIntentDone: function () {
      this.isLoading = false;
    },
    refresh: function () {
      if (this.defaultSelected != "bank_transfer") {
        return this.$refs["payment-form"].refresh();
      }
    },
  },
  mixins: [ConfigMixin],
  props: {
    paymentMethodSelected: {
      default: "none",
      type: String
    },
    paymentMethodChange: Function,
    companyId: String,
    companyName: String,
    services: Array,
    maxRetry: Number,
    paymentMethodTypes: Array,
    couponCode: String,
  },
  data() {
    return {
      authToken: '',
      defaultSelected: this.paymentMethodSelected,
      isLoading: true,
      isShowBankTransfer: true,
      excludeErrors: [],
    };
  }
};
</script>